// Pluck a value out of a string if after a symbol
function returnSubString(string, symbol) {
    let start = string.lastIndexOf(symbol);
    return string.substring(start+1);
}

export { returnSubString };




// WEBPACK FOOTER //
// ./src/utils/string.js